import { Size, Color } from '@opallabs/gem'
import { Tooltip, Icon, Button } from '@opallabs/lapidary'

type ControlButtonProps = {
  buttonName: string
  glyph: string
  tooltipContent: string
}

export const ControlButton: React.FC<ControlButtonProps> = ({
  buttonName,
  glyph,
  tooltipContent,
}) => (
  <Tooltip content={tooltipContent} side="top" legacyTheme="dark" zIndex={999}>
    <Button
      ariaLabel={buttonName}
      name={buttonName}
      icon={
        <Icon
          glyph={glyph}
          height={Size.Icon}
          width={Size.Icon}
          styleOverrides={{
            icon: {
              '&:hover': {
                color: Color.dark.Surface.A200,
              },
            },
          }}
        />
      }
      styleOverrides={{
        button: { blockSize: 26, '&.icon-only': { paddingInline: 4 } },
      }}
      theme="dark"
      variant="tertiary"
    />
  </Tooltip>
)
